import { Divider, Stack, Text, Title } from '@mantine/core';
import { modals } from '@mantine/modals';

import { IconCheck, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from '../../shared/components/UI/Button/Button';
import { Loader } from '../../shared/components/UI/Loader/Loader';

import { EditStreamLayout } from '../../features/streams/components/EditStreamLayout';
import { AdvancedFields } from '../../features/streams/components/forms/components/AdvancedFields';
import { BasicFields } from '../../features/streams/components/forms/components/BasicFields';
import {
  useDeleteStreamMutation,
  useStreamQuery,
} from '../../features/streams/components/forms/hooks/streams.hook';
import { useStreamForm } from '../../features/streams/components/forms/hooks/useStreamForm';

export default function UpdateStreamPage() {
  const { id } = useParams();
  const streamId = Number(id);
  const navigate = useNavigate();
  const { t } = useTranslation('stream');

  const {
    form,
    isFormValid,
    isFormDirty,
    searchTendersPreviewQuery,
    updateStream,
    queryKeys,
  } = useStreamForm(streamId);

  const streamQuery = useStreamQuery(streamId);

  if (streamQuery.isLoading) {
    return <Loader title="Chargement..." />;
  }

  const handleBackNav = () => {
    if (isFormDirty) {
      modals.openContextModal({
        modal: 'streamDiscard',
        size: 'lg',
        innerProps: {
          isFormValid,
          onDiscard: () => navigate(-1),
          onSubmit: () => {
            updateStream();
            navigate(-1);
          },
        },
      });
    } else {
      navigate(-1);
    }
  };

  const footerCTA = (
    <Button leftIcon={<IconCheck />} onClick={updateStream}>
      {t('updateStream.update')}
    </Button>
  );

  return (
    <EditStreamLayout
      handleBackNav={handleBackNav}
      footerCTA={footerCTA}
      queryKeys={queryKeys}
      previewQuery={searchTendersPreviewQuery}
    >
      <BasicFields form={form} />
      <AdvancedFields form={form} isOpened />
      <Divider size={1} />
      <DeleteSection streamId={streamId} />
    </EditStreamLayout>
  );
}

function DeleteSection({ streamId }: { streamId: number }) {
  const { t } = useTranslation('stream');
  const deleteStreamMutation = useDeleteStreamMutation();

  const handleDelete = () => {
    modals.openContextModal({
      modal: 'streamDelete',
      innerProps: { onDelete: () => deleteStreamMutation.mutate(streamId) },
    });
  };

  return (
    <Stack>
      <Title order={4}>{t('updateStream.deleteStream.title')}</Title>
      <Text variant="sm">{t('updateStream.deleteStream.description')}</Text>
      <Button
        onClick={handleDelete}
        leftIcon={<IconTrash size={18} />}
        maw="25%"
        miw="200px"
        size="md"
        color="red"
      >
        {t('updateStream.deleteStream.deleteStream')}
      </Button>
    </Stack>
  );
}
